<script>
    export let size = "regular";
    export let checked = false;
    export let outline = false;
    export let block = false;
    export let absolute = false;
    export let cssClass = '';
</script>

<span class="checkbox-box { size } { cssClass }"
      class:absolute={ absolute } class:outline={ outline } class:checked={ checked } class:block={ block }>
    {#if checked}
        <span class="check-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
        </span>
    {/if}
</span>

<style>
    .checkbox-box {
        display: inline-block;
        position: relative;
        line-height: 1;
        border: 1px solid #999;
        border-radius: 3px;
        color: #fff;
    }

    .checkbox-box.absolute {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .checkbox-box.block {
        display: block;
    }

    .checkbox-box.small {
        width: 14px;
        height: 14px;
        border-width: 1px;
        border-radius: 2px;
    }

    .checkbox-box.regular {
        width: 1rem;
        height: 1rem;
        border-width: 1px;
    }

    .checkbox-box.medium {
        width: 18px;
        height: 18px;
    }

    .checkbox-box.large {
        width: 20px;
        height: 20px;
    }

    .checkbox-box.extra-large {
        width: 23px;
        height: 23px;
    }

    .checkbox-box.checked {
        background: #03a9f4;
        border-color: #03a9f4;
    }

    .checkbox-box .check-icon {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 1;
        width: calc(100% - 4px);
    }

    .checkbox-box.outline {
        color: #6e6e6e;
    }

    .checkbox-box.outline.checked {
        background: #fff;
        border-color: #999;
    }
</style>